export function getPaddingStyle(size) {
  return {
    padding: size + "px"
  };
}
